import { render, staticRenderFns } from "./Deducciones.vue?vue&type=template&id=4d8efc28"
import script from "./Deducciones.vue?vue&type=script&lang=js"
export * from "./Deducciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports